import { Receipt } from "../types";
import { PaymentStatus, FraudStatus, RechargeStatus } from "../types-enums";

declare type ScreenType = 'blocked-refunded' | 'error-generic' | 'fraud' | 'payment-failed' |
    'payment-onhold' | 'payment-suspended' | 'recharge-failed' | 'recharge-invalid-no' |
    'recharge-successful' | 'recharge-timeout' | 'recharge-transient-failure' |'recharge-failed-data-plan';

export function getScreenType (receipt: Receipt): ScreenType {
    if (receipt.paymentStatus === PaymentStatus.Failed) {
        return 'payment-failed';
    }
    if (receipt.paymentStatus === PaymentStatus.Refunded 
        || receipt.paymentStatus === PaymentStatus.Authorized || receipt.paymentStatus === PaymentStatus.Released ) {
        if (receipt.fraudStatus === FraudStatus.Blocked || receipt.fraudStatus === FraudStatus.VerificationRequired) {
            return 'blocked-refunded';
        }
        if (receipt.transactionRecharges && receipt.transactionRecharges.responseCode === '501') {
            return 'recharge-invalid-no';
        } else if (receipt.transactionRecharges && receipt.rechargeStatus === RechargeStatus.Transient) {
            return 'recharge-transient-failure';
        } else if (receipt.transactionRecharges && receipt.transactionRecharges.responseCode === '507') {
            return 'recharge-failed-data-plan';
        }        
        else {
            return 'recharge-failed';
        }
    } else if (receipt.paymentStatus === PaymentStatus.Suspended) {
        return 'payment-suspended';
    } else if (receipt.paymentStatus === PaymentStatus.OnHold) {
        return 'payment-onhold';
    } else if (receipt.fraudStatus === FraudStatus.VerificationRequired || receipt.fraudStatus === FraudStatus.Blocked) {
        return 'fraud';
    } else if (receipt.rechargeStatus === RechargeStatus.Successful) {
        return 'recharge-successful';
    } else if (receipt.rechargeStatus === RechargeStatus.Timeout) {
        return 'recharge-timeout';
    } else if (receipt.rechargeStatus === RechargeStatus.Transient) {
        return 'recharge-transient-failure';
    } else if (receipt.paymentStatus === PaymentStatus.Successful &&
        receipt.fraudStatus === FraudStatus.NoVerificationRequired &&
        receipt.rechargeStatus === RechargeStatus.Pending) {
        //TODO: Here recharge status is pending even after payment is successful and no case of fraud
        return 'recharge-timeout';
    }
    return 'error-generic';
}
